import { render, staticRenderFns } from "./partnerDetail.vue?vue&type=template&id=38071f3d&scoped=true&"
import script from "./partnerDetail.vue?vue&type=script&lang=tsx&"
export * from "./partnerDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./partnerDetail.vue?vue&type=style&index=0&id=38071f3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38071f3d",
  null
  
)

export default component.exports